// ==============================================================
// File: client/src/scenes/loans/MyLoans.jsx (add Create button + dialog)
// ==============================================================
import React, { useState, useCallback } from "react";
import { Box, Tabs, Tab, useTheme, Button, Stack, alpha, useMediaQuery } from "@mui/material";
import Header from "components/Header";
import LoanApplicationsTable from "./LoanApplicationsTable";
import LoanScheduleTable from "./LoanScheduleTable";
import LoanApplicationForm from "./LoanApplicationForm";
import { useMutation } from "@apollo/client";
import { BOOK_LOAN_APPLICATION } from "../../graphql/loans";

const MyLoans = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [tab, setTab] = useState(0);
  const [open, setOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  // ✅ No alerts here. Child will show Snackbars based on returned status.
  const [bookLoan, { loading: submitting }] = useMutation(BOOK_LOAN_APPLICATION);

  // ✅ IMPORTANT: return the mutation result so the child can read status/errorMessage
  const handleSubmit = useCallback(
    async (payload) => {
      const res = await bookLoan({ variables: { input: payload } });

      // If successful, close dialog + refresh tables
      const sp = res?.data?.bookLoanApplication;
      if (sp?.status && String(sp.status).toLowerCase() === "success") {
        setOpen(false);
        setRefreshKey((k) => k + 1);
      }

      return res; // child uses extractSpStatus(res)
    },
    [bookLoan]
  );

  return (
    <Box sx={{ m: { xs: "0.75rem", sm: "1rem 1.5rem", md: "1.5rem 2.5rem" }, minWidth: 0 }}>
      <Stack direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "stretch", sm: "center" }} justifyContent="space-between" spacing={1.25}>
        <Header title="MY LOANS" subtitle="Loan Applications and Repayment Schedule" />
        <Button fullWidth={isMobile} variant="contained" color="secondary" onClick={() => setOpen(true)}>
          Apply for a Loan
        </Button>
      </Stack>

      <Box sx={{ borderBottom: 1, borderColor: alpha(theme.palette.secondary[200], 0.2), mb: 2, mt: 2 }}>
        <Tabs value={tab} onChange={(e, v) => setTab(v)} variant={isMobile ? "scrollable" : "standard"} scrollButtons="auto" allowScrollButtonsMobile sx={{ minHeight: 44 }}>
          <Tab label="Loan Applications" />
          <Tab label="Repayment Schedule" />
        </Tabs>
      </Box>

      {tab === 0 && <LoanApplicationsTable refreshToken={refreshKey} />}
      {tab === 1 && <LoanScheduleTable />}

      <LoanApplicationForm
        open={open}
        onClose={() => setOpen(false)}
        onSubmit={handleSubmit}
        submitting={submitting}
      />
    </Box>
  );
};

export default MyLoans;
